/**
 * Swaps consumer-facing "interest" labels with Shariah-compliant "profit"
 * terminology when useProfitRateTerminology is enabled for a DP_LP.
 */
export const withProfitRateTerminology = (
  label: string,
  useProfitRateTerminology?: boolean
): string => {
  if (!useProfitRateTerminology) {
    return label;
  }

  return label
    .replace(/\bInterest\b/g, "Profit")
    .replace(/\binterest\b/g, "profit");
};
